//Rebilly Test Card Numbers: https://docs.rebilly.com/docs/payments/testing-transactions/#approved-transaction
export const API_URLS = {
    local: 'https://dev-checkout-apollo.xy.company',
    prod: 'https://production-checkout-apollo.xy.company',
};
export const API_STAGES = {
    local: 'sandbox',
    prod: 'live',
};
//# sourceMappingURL=api.js.map